import { createAction, props } from '@ngrx/store';
import { ILeadData, ILeadModel } from '@partners/api';

export class LeadActions {
  static reset = createAction('[Lead] Reset State');
  static load = createAction('[Lead] Load');
  static loadSuccess = createAction('[Lead] Load Success', props<{ model: ILeadModel; data: ILeadData }>());
  static loadFailure = createAction('[Lead] Load Failure', props<{ error: any }>());
  static submit = createAction('[Lead] Submit', props<{ model: ILeadModel }>());
  static submitSuccess = createAction('[Lead] Submit Success', props<{ model: ILeadModel; data: ILeadData }>());
  static submitFailure = createAction('[Lead] Submit Failure', props<{ error: any }>());
}
